var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"picture",class:_vm.image.from === 'me' ? 'me' : '',attrs:{"src":_vm.image.imageUri,"alt":_vm.image.accessibilityText}})
}
var staticRenderFns = []

export { render, staticRenderFns }